/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import jMoment from 'moment-jalaali'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import CRM from '../BaseComponent/CRM'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class ReportDefinition extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      definitionTypes: [],
      deleteModal: false,
      editModal: false,
      definitionName: '',
      definitionEnable: '',
      definitionId: '',
      categoryId: '',
      subjectList: [],
      printInfo: [],
      categoryList: []
    }
  }

  callReportDefinition = () => {
    http.get(`${CRM.CRM_CONTACT_DEFINITION_REPORT}`, {}).then((response) => {
      if (response.data.error == null) {
        // alert(JSON.stringify(response.data))
        this.setState({
          definitionTypes: response.data.object.result,
          total: response.data.object.countAll
        })
      } else {
        this.setState({
          definitionTypes: []
        })
      }
    })
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    this.callReportDefinition()

    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState({
          categoryList: response.data.object
        })
      } else {
        this.setState({
          categoryList: []
        })
      }
    })
  }

  onResultFetched(data) {
    this.setState({
      definitionTypes: data
    })
  }

  changeDropDown(data) {
    this.setState({
      definitionTypes: data,
      lengthProducts: this.state.total
    })
  }

  deletedefinition = (id, name) => {
    sessionStorage.setItem('definitionId', id)
    this.setState({
      deleteModal: !this.state.deleteModal,
      definitionName: name
    })
  }
  toggleDelete = () => {
    sessionStorage.removeItem('definitionId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      definitionName: ''
    })
  }
  deleteCancel = () => {
    sessionStorage.removeItem('definitionId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      definitionName: ''
    })
  }
  deleteOk = () => {
    let contactDefinitionId = sessionStorage.getItem('definitionId')
    let data = {
      contactDefinitionId
    }
    http.post(`${CRM.CRM_CONTACT_DEFINITION_REMOVE}`, data, {}).then((response) => {
      if (response.data.error == null) {
        message.success('جزییات تماس با موفقیت حذف شد')
        this.deleteCancel()
        this.callReportDefinition()
      } else {
        message.error(response.data.description)
      }
    })
  }

  editdefinition = (id, name, enable, subjectId, contactCategoryId) => {
    this.setState({
      editModal: !this.state.editModal,
      definitionId: id,
      definitionName: name,
      definitionEnable: enable,
      subjectId,
      contactCategoryId
    })

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${contactCategoryId}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          subjectList: response.data.object
        })
      } else {
        this.setState({
          subjectList: []
        })
      }
    })
  }
  editCancel = () => {
    this.setState({
      editModal: !this.state.editModal,
      definitionId: '',
      definitionName: '',
      definitionEnable: '',
      contactCategoryId: ''
    })
  }
  toggleEdit = () => {
    this.editCancel()
  }
  editOk = () => {
    let {contactCategoryId} = this.state
    var name = document.getElementById('name').value
    var contactSubjectId = document.getElementById('contactSubjectId').value
    var enabled = document.getElementById('enabled').value
    let data = {
      name,
      enabled,
      contactDefinitionId: this.state.definitionId,
      contactSubjectId,
      contactCategoryId: ''
    }

    http.post(`${CRM.CRM_CONTACT_DEFINITION_UPDATE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('ویرایش با موفقیت انجام شد')
        this.editCancel()
        this.callReportDefinition()
      } else {
        message.error(response.data.description)
      }
    })
  }

  exportExcel = () => {
    http
      .get(
        `${CRM.CRM_CONTACT_DEFINITION_REPORT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${CRM.CRM_CONTACT_DEFINITION_REPORT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  changeCategory = (e) => {
    let value = e.target.value
    if (value === '') {
      this.setState({
        subjectList: []
      })
    } else {
      http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?contactCategoryId=${value}`, {}).then((response) => {
        if (response.data.error == null) {
          this.setState({
            subjectList: response.data.object
          })
        } else {
          this.setState({
            subjectList: []
          })
        }
      })
    }
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'خانواده تماس', 'موضوع تماس', 'عنوان', 'وضعیت']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="ارتباط با مشتری - جزییات تماس"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((media, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{media.contactCategoryName}</td>
                  <td>{media.contactSubjectName}</td>
                  <td>{media.contactDefinitionName}</td>
                  <td>{media.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="ارتباط با مشتری - جزییات تماس.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'contactCategoryName'}
                field={'contactCategoryName'}
                title={'خانواده تماس'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'contactSubjectName'}
                field={'contactSubjectName'}
                title={'موضوع تماس'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'contactDefinitionName'}
                field={'contactDefinitionName'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>ارتباط با مشتری</li>
            <li>جزییات تماس</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/addDefinition"
                  url={CRM.CRM_CONTACT_DEFINITION_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={CRM.CRM_CONTACT_DEFINITION_REPORT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>خانواده تماس</td>
                    <td>موضوع تماس</td>
                    <td>عنوان</td>
                    <td>وضعیت فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>

                  {this.state.definitionTypes.map((definition, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{definition.contactCategoryName}</td>
                      <td>{definition.contactSubjectName}</td>
                      <td>{definition.contactDefinitionName}</td>
                      <td>
                        {definition.enabled ? (
                          <img src={require('../../image/confirm.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/ignor.svg')} alt="" />
                        )}
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.editdefinition(
                              definition.contactDefinitionId,
                              definition.contactDefinitionName,
                              definition.enabled,
                              definition.contactSubjectId,
                              definition.contactCategoryId
                            )
                          }
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.deletedefinition(definition.contactDefinitionId, definition.contactDefinitionName)
                          }
                        >
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.total}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={CRM.CRM_CONTACT_DEFINITION_REPORT}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.deleteModal} toggle={this.toggleDelete} size="sm">
          <ModalHeader toggle={this.toggleDelete}>حذف جزییات تماس</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف جزییات تماس {this.state.definitionName} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف جزییات تماس
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.toggleEdit} size="sm">
          <ModalHeader toggle={this.toggleEdit}>ویرایش جزییات تماس</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label>خانواده تماس : </label>
                <select className="form-control" id="category" onChange={this.changeCategory.bind(this)}>
                  <option value="">------</option>
                  {this.state.categoryList.map((category, index) => (
                    <option
                      selected={this.state.contactCategoryId === category.contactCategoryId ? true : false}
                      value={category.contactCategoryId}
                    >
                      {category.contactCategoryName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label>موضوع تماس </label>
                <select className="form-control" id="contactSubjectId">
                  {this.state.subjectList.map((category, index) => (
                    <option
                      selected={this.state.subjectId === category.contactSubjectId ? true : false}
                      value={category.contactSubjectId}
                    >
                      {category.contactSubjectName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label> نام جزییات تماس: </label>
                <input className="form-control" type="text" defaultValue={this.state.definitionName} id="name" />
              </div>
              <div className="formComponent">
                <label> وضعیت جزییات تماس: </label>

                <select className="form-control" name="enabled" id="enabled">
                  <option selected={this.state.definitionEnable === 1 ? true : false} value={1}>
                    فعال
                  </option>
                  <option selected={this.state.definitionEnable === 0 ? true : false} value={0}>
                    غیر فعال
                  </option>
                </select>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش جزییات تماس
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ReportDefinition
